import React  from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
function StyledTableRow(props)
{
  return <TableRow classes={{root: "StyledTableRow"}} {...props}></TableRow>
}
// const StyledTableRowC = withStyles((theme) => ({
//   root: {
//     '&:nth-of-type(even)': {
//       backgroundColor: theme.palette.action.hover,
//     },
//   },
// }))(TableRow);
function StyledTableCell(props)
{
  return <TableCell 
  classes={{
    head: "StyledTableCell", 
    body: {
    fontSize: 14,
    }
  }} {...props}></TableCell>
}
// const StyledTableCell = withStyles((theme) => ({
//     head: {
//         backgroundColor: "rgb(245,245,245)",
//         color: "black",
//     },
//     body: {
//       fontSize: 14,
//     },
//   }))(TableCell);
const StyledTableCellPadding = withStyles((theme) => ({
    root: {
        paddingTop: 8,
        paddingBottom: 8
    },
    head: {
      backgroundColor: "rgb(245,245,245)",
      color: "black",
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  export {
    StyledTableRow,
    StyledTableCell,
    StyledTableCellPadding
  }